import { render, staticRenderFns } from "./shipday_export.vue?vue&type=template&id=35bd5b84&scoped=true&"
import script from "./shipday_export.vue?vue&type=script&lang=js&"
export * from "./shipday_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd5b84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35bd5b84')) {
      api.createRecord('35bd5b84', component.options)
    } else {
      api.reload('35bd5b84', component.options)
    }
    module.hot.accept("./shipday_export.vue?vue&type=template&id=35bd5b84&scoped=true&", function () {
      api.rerender('35bd5b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/shipday/shipday_export.vue"
export default component.exports